module.exports = __webpack_public_path__ + "platform-web/static/media/help.f8cc3823.svg";